import { render, staticRenderFns } from "./JgpBtn.vue?vue&type=template&id=7ca6a1aa&"
import script from "./JgpBtn.vue?vue&type=script&lang=js&"
export * from "./JgpBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports